import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";

import { getFirstdayoftheWeek } from "utils/reusableFunctions";

dayjs.extend(updateLocale);

const startDayOfWeek = getFirstdayoftheWeek(JSON.parse(localStorage.getItem("day")));

dayjs.updateLocale("en", {
  weekStart: startDayOfWeek
});

const DRSDatePicker = ({ format = "DD/MM/YYYY", allowClear = true, ...props }) => {
  return <DatePicker format={format} allowClear={allowClear} {...props} />;
};

export default DRSDatePicker;
